import { axiosInstance } from "./common";
import { extractFileDownload, FileDownload } from "./download";
import { fileDateStamp } from "../lib/utils";

export enum ReportType {
  INVESTIGATION_REPORT = "investigation-report",
  PRELIMINARY_REPORT = "preliminary-report",
}

export interface CoverLetterInputs {
  addressee?: string | null;
  regarding?: string | null;
  reference?: string | null;
  introduction?: string | null;
  body?: string | null;
  signatory_name?: string | null;
}

export const InvestigationReportAPI = {
  download: async (
    caseId: string,
    reportType: ReportType,
    caseUin: string,
    cover_letter?: CoverLetterInputs,
    timezone: string = "Asia/Kolkata"
  ): Promise<FileDownload> => {
    const response = await axiosInstance.post<Blob>(
      `/v1/cases/${caseId}/reports/${reportType}/download`,
      { cover_letter },
      {
        params: { timezone },
        responseType: "blob",
      }
    );

    return extractFileDownload(response, `${reportType}_${caseUin}_${fileDateStamp()}.docx`);
  },
};